import React, { useEffect } from 'react';
import TextSubHeader from 'components/CustomText/TextSubHeader';
import CustomButton from 'components/CustomInput/Button';
import CustomTable from 'components/CustomTable';
import useLeadPITableData from 'hooks/tableData/useLeadPITableData';
import TipsIcon from 'components/TipsIcon';
import styled from 'styled-components';
import MemberDialog from './MemberDialog';
import useDialog from 'components/ConfirmDialog/useDialog';
import { EMAIL_EXIST_EMAIL, THREE_SITE_PI_ALLOWED } from 'utility/frontendMessage';
import { compareEmail, produce } from 'utility/general';
import { getStore } from 'store';

const SHeaderLayout = styled.div`
    padding-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const CIDelegationTable = ({
    onTableChange = (data) => null,
    defaultData = [],
    isFormCreate = false,
    disableOnPermission = false,
    applicationDetail,
    piTableData = [],
    onTableDataUpdate = (data) => null,
    isAmendmentCreate = false,
    isAmendmentEdit = false,
    isHighlight,
}) => {
    const {
        openPopup,
        setOpenPopup,
        columns,
        rows,
        triggerCreateForm,
        onRecordUpdate,
        handleDeleteAfterCreation,
        handleEditAfterCreation,
        handleCreateAfterCreation,
        setRows,
        selectedRow,
        isEdit,
        handleEditClick,
    } = useLeadPITableData({ formId: applicationDetail?.applicationForm?.id });

    const showDialog = useDialog();

    const isAmendment = isAmendmentCreate || isAmendmentEdit;

    // initialize the study-info postData if edit data exist
    useEffect(() => {
        const { applicationDetailPostData } = getStore().getState();
        const ciDelegation = applicationDetailPostData.postData?.ciDelegation ?? [];
        setRows([...rows, ...ciDelegation]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // update table data to parent
    useEffect(() => {
        onTableDataUpdate(rows);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rows]);

    const checkEmailExistInForm = (data, isUpdate = false) => {
        let isExist = false;

        // piTableData.forEach((item) => {
        //     if (item.email === data.email) {
        //         isExist = true;
        //     }
        // });

        rows.filter((item) => {
            if (isUpdate) {
                return item.id !== data.id;
            }

            return true;
        }).forEach((item) => {
            if (compareEmail(item.email, data.email)) {
                isExist = true;
            }
        });

        return isExist;
    };

    const onDataCreate = async (data) => {
        let isEmailExistInTeamMember = checkEmailExistInForm(data);

        if (isEmailExistInTeamMember) {
            return await showDialog({
                description: EMAIL_EXIST_EMAIL,
                disableCancelButton: true,
            });
        }

        // creating a brand new initial application form
        if (isFormCreate) {
            onRecordUpdate(data);
            setOpenPopup(false);
            // notify parent the whole post data of the table
            onTableChange([...rows, data]);
        } else {
            handleCreateAfterCreation(data);
            setOpenPopup(false);
        }
    };

    const onEditData = async (data) => {
        let isEmailExistInTeamMember = checkEmailExistInForm(data, true);

        if (isEmailExistInTeamMember) {
            return await showDialog({
                description: EMAIL_EXIST_EMAIL,
                disableCancelButton: true,
            });
        }

        if (isFormCreate) {
            const newRows = produce(rows, (draft) => {
                const index = draft.findIndex((item) => {
                    return item.id === data.id;
                });

                draft[index] = data;
            });

            onTableChange(newRows);
            setOpenPopup(false);
            setRows(newRows);
        } else {
            handleEditAfterCreation(data);
            setOpenPopup(false);
        }
    };

    const onDeleteData = (data) => {
        if (isFormCreate) {
            const newRows = produce(rows, (draft) => {
                const index = draft.findIndex((item) => item.id === data.id);
                draft.splice(index, 1);
            });

            onTableChange(newRows);
            setOpenPopup(false);
            setRows(newRows);
        } else {
            handleDeleteAfterCreation(data);
        }
    };

    return (
        <div>
            <SHeaderLayout>
                <TextSubHeader>
                    <span style={{ background: isHighlight(['ciDelegation'], true) ? 'yellow' : 'initial' }}>
                        Coordinating Investigator's Delegation
                    </span>
                    <TipsIcon
                        title={[
                            'Assist Coordinating Investigator for Initial Application submission and study-based Post-approval Applications (Max=3 users)',
                        ]}
                    />
                </TextSubHeader>
                <CustomButton
                    disableOnPermission={disableOnPermission || isAmendment}
                    onClick={() => {
                        if (rows.length >= 3) {
                            return showDialog({
                                description: THREE_SITE_PI_ALLOWED,
                                disableCancelButton: true,
                            });
                        }

                        triggerCreateForm();
                    }}
                >
                    Add
                </CustomButton>
            </SHeaderLayout>
            {openPopup && (
                <MemberDialog
                    title={`${selectedRow?.email ? 'Edit' : 'Adding'} coordinating investigator's delegation`}
                    isDelegateDialog
                    selectedRow={selectedRow}
                    restrictApplicant
                    onDialogCancel={() => setOpenPopup(false)}
                    onCreateSubmit={onDataCreate}
                    onEditSubmit={onEditData}
                    isEdit={isEdit}
                />
            )}

            <CustomTable
                disableOnPermission={disableOnPermission || isAmendment}
                isEditAllow
                onDelete={onDeleteData}
                onEdit={handleEditClick}
                isDeleteAllow
                fullWidthTable
                columns={columns}
                rows={rows}
            />
        </div>
    );
};

export default CIDelegationTable;
